import { Injectable, inject } from '@angular/core';
import { AuthenticationService } from '@api/index';

@Injectable({ providedIn: 'root' })
export class IdentityProviderService {
  // Services
  private authenticationService = inject(AuthenticationService);

  public getConfigurationKey(key: string, useDefault = false): string {
    const prefix = 'public.authentication-config';
    const idp = !useDefault && sessionStorage.getItem('idp') ? `${sessionStorage.getItem('idp')}.` : '';

    return `${prefix}.${idp}${key}`;
  }
}
